import React, { useState } from "react";
import { db } from "../../services/firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { USE_LOCAL_FALLBACK } from "../../config/firebaseConfig";

export default function DataCleanup() {
  const [nameQuery, setNameQuery] = useState("Warlito Castro");
  const [campus, setCampus] = useState("");
  const [log, setLog] = useState("");
  const [busy, setBusy] = useState(false);

  function append(msg) {
    setLog(l => (l ? l + "\n" : "") + msg);
  }

  async function deleteMatching() {
    setBusy(true);
    setLog("");
    try {
      const q = String(nameQuery || "").trim().toLowerCase();
      if (!q) { append("Please enter a name to match."); return; }
      // Local removal (dev or cached)
      try {
        const raw = localStorage.getItem("students");
        if (raw) {
          const list = JSON.parse(raw).filter(s => {
            const name = String(s.fullname || `${s.firstName || ""} ${s.lastName || ""}`).toLowerCase();
            const campusLC = String(s.campus || "").toLowerCase();
            if (campus && campusLC !== campus) return true;
            return !name.includes(q);
          });
          localStorage.setItem("students", JSON.stringify(list));
          append(`Local list cleaned.`);
        }
        const cacheRaw = localStorage.getItem("students_fs_cache");
        if (cacheRaw) {
          const cache = JSON.parse(cacheRaw).filter(s => {
            const name = String(s.fullname || `${s.firstName || ""} ${s.lastName || ""}`).toLowerCase();
            const campusLC = String(s.campus || "").toLowerCase();
            if (campus && campusLC !== campus) return true;
            return !name.includes(q);
          });
          localStorage.setItem("students_fs_cache", JSON.stringify(cache));
          append(`Local Firestore cache cleaned.`);
        }
      } catch { /* ignore */ }

      if (!USE_LOCAL_FALLBACK) {
        const snap = await getDocs(collection(db, "students"));
        const docs = snap.docs.filter(d => {
          const data = d.data() || {};
          const name = String(data.fullname || `${data.firstName || ""} ${data.lastName || ""}`).toLowerCase();
          const campusLC = String(data.campus || "").toLowerCase();
          if (campus && campusLC !== campus) return false;
          return name.includes(q);
        });
        append(`Found ${docs.length} matching student(s) in Firestore.`);
        let count = 0;
        for (const d of docs) {
          // eslint-disable-next-line no-await-in-loop
          await deleteDoc(doc(db, "students", d.id));
          count += 1;
        }
        append(`Deleted ${count} student(s) from Firestore.`);
      } else {
        append("Running in local fallback; skipped Firestore delete.");
      }
      append("Cleanup complete.");
    } catch (e) {
      append(`Error: ${e.message || String(e)}`);
    } finally {
      setBusy(false);
    }
  }

  function clearCaches() {
    try {
      localStorage.removeItem("students_fs_cache");
      append("Cleared local students_fs_cache.");
    } catch {
      append("Failed to clear local cache.");
    }
  }

  return (
    <div className="container py-4">
      <h3 className="mb-3">Data Cleanup</h3>
      <div className="alert alert-warning">
        This tool deletes matching student records. Use carefully.
      </div>
      <div className="row g-2 mb-3">
        <div className="col-md-6">
          <label className="form-label">Match Name (contains)</label>
          <input className="form-control" value={nameQuery} onChange={e => setNameQuery(e.target.value)} placeholder="e.g., Warlito Castro" />
        </div>
        <div className="col-md-3">
          <label className="form-label">Campus (optional)</label>
          <select className="form-select" value={campus} onChange={e => setCampus(e.target.value)}>
            <option value="">All</option>
            <option value="gapan">gapan</option>
            <option value="bulacan">bulacan</option>
          </select>
        </div>
      </div>
      <div className="d-flex gap-2 mb-3">
        <button className="btn btn-danger" onClick={deleteMatching} disabled={busy}>
          Delete Matching Students
        </button>
        <button className="btn btn-outline-secondary" onClick={clearCaches} disabled={busy}>
          Clear Local Cache
        </button>
      </div>
      <div className="card">
        <div className="card-body">
          <h6 className="mb-2">Results</h6>
          <pre style={{ whiteSpace: "pre-wrap" }}>{log || "No logs yet"}</pre>
        </div>
      </div>
    </div>
  );
}
